import Vue from 'vue';
import feathersClient from '../../feathers-client';

export default {
	state: {
		autoOffer: [],
	},
	getters: {

	},
	mutations: {
		SET_AUTO_OFFER: (state, offer) => { state.autoOffer = offer; },
	},
	actions: {
		getAutoOffer: async({rootGetters,commit},id) => {
			const results = await feathersClient.service('/api/v3/auto-offer-configurations').find({
				query:{
					$role: rootGetters.currentUserRole,
					trustId:id,
				}
			});
			if(results.data.length === 0){
				const obj = {
					autoOfferTimeOutWeight:0,
					offerAcceptTimeOut:0,
				};
				results.data.push(obj);
			}
			commit('SET_AUTO_OFFER',results.data);
			return results.data;
		},
		updateAutoOffer: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/auto-offer-configurations').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},

		getAutoOfferById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/auto-offer-configurations').find({
				query:{
					$role: rootGetters.currentUserRole,
					trustId:id,
				}
			});

			return results
		},
		createAutoOffer: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/auto-offer-configurations').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},

	},
};
